<template>
  <div
    class="card search-sort-card is-shadowless has-background-primary-lightest"
  >
    <div class="card-content">
      <form class="search-sort-form" action="#">
        <div class="columns is-variable is-1">
          <div class="column is-4-tablet is-3-desktop">
            <div class="search-form">
              <div class="control">
                <label class="label" for="search-terms-3">{{
                  searchDefinitions.search_term_label.length > 0
                    ? searchDefinitions.search_term_label
                    : "Search keyword"
                }}</label>
                <input
                  type="text"
                  class="text"
                  id="search-terms-3"
                  placeholder="Keyword search"
                  :value="searchFilters.keyword"
                  v-on:keyup="updateSearchKeyword($event)"
                />
                <button
                  @click="callSearch($event)"
                  type="submit"
                  class="btn-search"
                >
                  <i class="icon icon-search"></i>
                  <span class="is-sr-only">{{
                    searchDefinitions.search_term_label
                  }}</span>
                </button>
              </div>
            </div>
          </div>
          <div
            class="column"
            v-for="facetIndex in Object.keys(facets).filter(
              (f) =>
                searchFilterOptions &&
                searchFilterOptions.options &&
                searchFilterOptions.options[f]
            )"
            :key="`filter-${facetIndex}`"
            :set="(facet = facets[facetIndex])"
          >
            <div class="control">
              <label class="label" for="content-type">{{
                searchFilterOptions.options[facetIndex].label
              }}</label>
              <div class="select">
                <select
                  id="content-type"
                  @change="handleChange($event, 'content_type')"
                >
                  <option value="">All</option>
                  <option
                    v-for="(option, index) of facet.showedOptions"
                    :key="`content-type-option-${index}`"
                    :value="option.value"
                    :selected="
                      searchFilters.filters['content_type'] &&
                      searchFilters.filters['content_type'].includes(
                        option.value.toString()
                      )
                    "
                  >
                    {{ option.title }}
                  </option>
                  <option
                    v-for="(option, index) of facet.hiddenOptions"
                    :key="`content-type-option-${index}`"
                    :value="option.value"
                    :selected="
                      searchFilters.filters['content_type'] &&
                      searchFilters.filters['content_type'].includes(
                        option.value.toString()
                      )
                    "
                  >
                    {{ option.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column"
            v-if="
              searchFilterOptions &&
              searchFilterOptions.options &&
              searchFilterOptions.options.date
            "
          >
            <div class="control datepicker">
              <label class="label" for="from">From</label>
              <input
                type="date"
                class="input"
                id="from"
                min="2000-01-01"
                :max="maxDateToday"
                placeholder="Any date"
                @change="handleChangeSingle($event, 'date_from')"
                :value="
                  searchFilters.filters['date_from']
                    ? searchFilters.filters['date_from']
                    : ''
                "
              />
            </div>
          </div>
          <div
            class="column"
            v-if="
              searchFilterOptions &&
              searchFilterOptions.options &&
              searchFilterOptions.options.date
            "
          >
            <div class="control datepicker">
              <label class="label" for="to">To</label>
              <input
                type="date"
                class="input"
                id="to"
                :min="minDateToDate"
                :max="maxDateToday"
                placeholder="Any date"
                @change="handleChangeSingle($event, 'date_to')"
                :value="
                  searchFilters.filters['date_to']
                    ? searchFilters.filters['date_to']
                    : ''
                "
              />
            </div>
          </div>
          <div
            class="column"
            v-if="
              searchDefinitions.sorting_options &&
              searchDefinitions.sorting_options.length > 0
            "
          >
            <div class="control">
              <label class="label" for="sort-3">Sort</label>
              <div class="select">
                <select id="sort-3" @change="updateSearchSort($event)">
                  <template v-for="opt of searchDefinitions.sorting_options">
                    <option
                      :value="`${opt.value}-desc`"
                      :key="`${opt.value}-desc`"
                      :selected="
                        searchFilters.sort[opt.value] &&
                        searchFilters.sort[opt.value] == 'desc'
                      "
                    >
                      {{ opt.name }} (desc)
                    </option>
                    <option
                      :value="`${opt.value}-asc`"
                      :key="`${opt.value}-asc`"
                      :selected="
                        searchFilters.sort[opt.value] &&
                        searchFilters.sort[opt.value] == 'asc'
                      "
                    >
                      {{ opt.name }} (asc)
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "FiltersTaxonomySearch",
  data() {
    return {
      keyword: "",
      dateFrom: "",
    };
  },
  computed: {
    ...mapGetters({
      searchFilters: "getSearchFilters",
      searchDefinitions: "getSearchDefinitions",
    }),
    ...mapState({
      facets: (state) => state.search.searchInfo.facets,
      searchFilterOptions: (state) => state.search.searchFilterOptions,
    }),
    maxDateToday() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      return yyyy + "-" + mm + "-" + dd;
    },
    minDateToDate() {
      if (this.dateFrom == "") {
        return "";
      }

      let [yyyy, mm, dd] = this.dateFrom.split("-");
      dd = parseInt(dd) + 1;

      if (dd < 10) {
        dd = "0" + dd;
      }

      return yyyy + "-" + mm + "-" + dd;
    },
  },
  methods: {
    callSearch(e) {
      e.preventDefault();

      this.$store.dispatch("assignGeneralSearchFilters", {
        keyword: this.keyword,
      });
      this.$store.dispatch("fetchGeneralSearch");
    },
    updateSearchKeyword(e) {
      e.preventDefault();
      this.keyword = e.target.value;

      if (e.keyCode === 13) {
        this.callSearch(e);
      }
    },
    handleChange: function (e, filterName) {
      const value = e.target.value;
      const filters = { ...this.searchFilters.filters };

      if (value.length > 0) {
        filters[filterName] = [value];
      } else {
        filters[filterName] = [];
      }

      this.$store.dispatch("assignGeneralSearchFilters", { filters });
      this.$store.dispatch("fetchGeneralSearch");
    },
    handleChangeSingle: function (e, filterName) {
      const value = e.target.value;
      const filters = { ...this.searchFilters.filters };

      if (filterName == "date_from") {
        this.dateFrom = value;
      }

      if (value.length > 0) {
        filters[filterName] = value;
      } else {
        filters[filterName] = "";
      }

      this.$store.dispatch("assignGeneralSearchFilters", { filters });
      this.$store.dispatch("fetchGeneralSearch");
    },
    updateSearchSort(e) {
      const sort = {};
      const [field, direction] = e.target.value.split("-");

      sort[field] = direction;

      this.$store.dispatch("assignGeneralSearchFilters", { sort });
      this.$store.dispatch("fetchGeneralSearch");
    },
  },
  mounted() {
    this.keyword = this.searchFilters.keyword;
  },
};
</script>
